module.exports = __webpack_public_path__ + "img/homepage_illustration.4f7d9db6.svg";